import { render, staticRenderFns } from "./auth-login-three.vue?vue&type=template&id=0a969317&"
import script from "./auth-login-three.vue?vue&type=script&lang=js&"
export * from "./auth-login-three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports